import { render, staticRenderFns } from "./AddTaskDialog.vue?vue&type=template&id=f42b973e&scoped=true&"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js&"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskDialog.vue?vue&type=style&index=0&id=f42b973e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42b973e",
  null
  
)

export default component.exports